import React from "react";
import MobilePaymentNavigation from "../../mobilePaymentNavigation/MobilePaymentNavigation";
import { PlusCircleOutlined } from "@ant-design/icons";
import UpiVpa from "../UpiVpa";
import UpiIntent from "./UpiIntent";
import { useTranslation } from "react-i18next";
import { getUpiVariant } from "../upiVariantConfig";

const UpiMobile = ({ upiMethodInfo, variant = "upi" }) => {
  const { t } = useTranslation()
  const cfg = getUpiVariant(variant);
  let upiCollect = upiMethodInfo?.find(
    (upiInfo) => upiInfo.brand === cfg.collectBrand
  );

  let upiIntent = upiMethodInfo?.find(
    (upiInfo) => upiInfo.brand === cfg.intentBrand
  );
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {upiIntent && (
        <div className="upi-intent-root">
          <UpiIntent upiData={upiIntent} variant={variant} />
        </div>
      )}

    </div>
  );
};

export default UpiMobile;
